import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';

function PaymentRedirectContainer() {
  const location = useLocation();
  const [url, setUrl] = useState('');
  useEffect(() => {
    const query = qs.parse(DOMPurify.sanitize(location.search));
    setUrl(query?.to);
  }, [location]);
  return (
    <div className="container shadow-lg mx-auto max-w-700 receipt-mask pb-6 bg-white">
      <div className="bg-white flex flex-wrap divide-x overflow-hidden p-10">
        <div className="text-left text-sm">
          Continue with your payment by clicking on{' '}
          <a
            className="text-blue-500 underline"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            this link.
          </a>
          <br />
          <br />
          If you have completed your transaction. You may close this window.
        </div>
      </div>
    </div>
  );
}

export default PaymentRedirectContainer;
